// CSS
import "../Page/Page.css"

// React
import React from "react";


interface imageObj{
     width?: string | number;
    imageSource: string;
}

const ImageComp: React.FC<imageObj> = ({ width, imageSource}) => {
    return (
        <div className="image-container">
            <div className="image-background">
                <img src={imageSource} alt="ElfTech Engine" className="image" style={{ width }}/>
            </div>
          
        </div>
    );
};

export default ImageComp;